import {Component, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TranslocoDirective} from "@jsverse/transloco";
import {PillLogoComponent, Size} from 'shared-lib';

@Component({
  selector: 'app-second-page',
  imports: [
    NgOptimizedImage,
    TranslocoDirective,
    PillLogoComponent
  ],
  templateUrl: './second-page.component.html',
  styleUrl: './second-page.component.scss'
})
export class SecondPageComponent {
  companyName = input.required<string>();
  companyLogo = input.required<string>();
  amountSpent = input<number>();
  protected readonly Size = Size;
}
